module.exports = __webpack_public_path__ + "img/icon-close-black.ac8d1e64.svg";